export default class MainMenu
{
	constructor()
	{
		this._navToggle = document.querySelector(".jsMainNavToggle");
		this._scrollDistance = 0;

		if (this._navToggle) this.init();
	}

	disableBodyScroll()
	{
		// Store the scroll distance
		this._scrollDistance = window.scrollY;
		// Position non-scrolling body content offset upwards by same amount.
		document.body.style.top = (this._scrollDistance * -1) + "px";
	}

	enableBodyScroll()
	{
		// Remove forced body vertical offset
		document.body.style.removeProperty('top');
		// Restore the scroll distance
		window.scrollTo(0, this._scrollDistance);
	}

	openNav()
	{
		// switch hb mode
		this.disableBodyScroll();
		document.body.classList.add("-navOpen");
	}

	closeNav()
	{
		document.body.classList.remove("-navOpen");
		this.enableBodyScroll();
	}

	init()
	{
		// Toggle the nav when the toggler button is clicked
		this._navToggle.addEventListener("click", () =>
		{
			if (document.body.classList.contains("-navOpen"))
			{
				this.closeNav();
			}
			else
			{
				this.openNav();
			}
		});

		// On resize into desktop layout, check if the nav is open. If so, close it.
		window.addEventListener( 'resize', () =>
		{
			if ( window.innerWidth > 1023 && document.body.classList.contains("-navOpen") )
			{
				this.closeNav();
			}
		});
	}
}
